import { render, staticRenderFns } from "./CustomerQa.vue?vue&type=template&id=64f67d66&scoped=true&"
import script from "./CustomerQa.vue?vue&type=script&lang=js&"
export * from "./CustomerQa.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQa.vue?vue&type=style&index=0&id=64f67d66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f67d66",
  null
  
)

export default component.exports